export default __webpack_public_path__ + "static/media/trash.e261f562.svg";